import { render } from "./QuestionEight.vue?vue&type=template&id=4e0468a7"
import script from "./QuestionEight.vue?vue&type=script&lang=js"
export * from "./QuestionEight.vue?vue&type=script&lang=js"

import "./QuestionEight.vue?vue&type=style&index=0&id=4e0468a7&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__